import { RemboursementType, RepriseMarchandiseType, AutorisationRemboursementEnMagasin, ChargerContactExclusionMotif, CompteEtat, CategorieCodes, QualificationCodes, ReclamationQualificationDetailCodes } from 'constants.js';

/**
 * Configuration des informations d'affichage pour les autorisations de remboursement en magasin
 */
export const autorisationRemboursementEnMagasinConfig = {
    [AutorisationRemboursementEnMagasin.NonAutorise]: {
        message: 'Remboursement interdit par le magasin (sera déduit facture fin de mois)',
        color: '#d32f2f', // Rouge
        description: 'Remboursement immédiat non autorisé'
    },
    [AutorisationRemboursementEnMagasin.Autorise]: {
        message: 'Remboursement client immédiat autorisé',
        color: '#2e7d32', // Vert
        description: 'Remboursement possible par le magasin'
    },
    [AutorisationRemboursementEnMagasin.ParComptaUniquement]: {
        message: 'Remboursement interdit par le magasin (par la compta uniquement)',
        color: '#ed6c02', // Orange
        description: 'Remboursement par la compta uniquement'
    },
    [AutorisationRemboursementEnMagasin.ParComptaUniquementMPU]: {
        message: 'Remboursement interdit par le magasin (sera déduit facture fin de mois)',
        color: '#ed6c02', // Orange
        description: 'Remboursement par la compta pour les Marchés Publics'
    },
    [AutorisationRemboursementEnMagasin.CarteAchat]: {
        message: 'Remboursement interdit par le magasin (client carte achat)',
        color: '#ed6c02', // Orange
        description: 'Remboursement par la compta pour les Marchés Publics en carte achat'
    },
    default: {
        message: 'Message à définir, svp !',
        color: '#9c27b0', // Violet
        description: 'Juste un texte pour qu\'on voit en front que c\'est manquant.'
    }
};

export const getMessageAutorisationRemboursementEnMagasin = (autorisationRemboursementEnMagasin) => {

    console.log("getMessageAutorisationRemboursementEnMagasin", autorisationRemboursementEnMagasin);

    const config = autorisationRemboursementEnMagasinConfig[autorisationRemboursementEnMagasin];

    if (config) {
        return config.message;
    }

    return autorisationRemboursementEnMagasinConfig.default.message;
}

/**
 * Retourne la configuration (couleur et message) pour une autorisation de remboursement en magasin
 * @param {number} autorisationRemboursementEnMagasin - Le type d'autorisation
 * @returns {{message: string, color: string, description: string}} Configuration contenant le message, la couleur et la description
 */
export const getConfigAutorisationRemboursementEnMagasin = (autorisationRemboursementEnMagasin) => {
    const config = autorisationRemboursementEnMagasinConfig[autorisationRemboursementEnMagasin];

    if (config) {
        return config;
    }

    return autorisationRemboursementEnMagasinConfig.default;
}

/**
 * Configuration des informations d'affichage pour le chargement des contacts
 */
export const chargerContactConfig = {
    [ChargerContactExclusionMotif.Aucun]: {
        message: 'Chargement des contacts actif',
        color: '#2e7d32', // Vert
    },
    [ChargerContactExclusionMotif.Activite]: {
        message: 'Chargement des contacts exclu : code activité exclu',
        color: '#d32f2f', // Rouge
    },
    [ChargerContactExclusionMotif.Compte]: {
        message: 'Chargement des contacts exclu : compte exclu',
        color: '#d32f2f', // Rouge
    },
    default: {
        message: 'Chargement des contacts : état inconnu',
        color: '#9c27b0', // Violet
    }
};

/**
 * Retourne la configuration (couleur et message) pour le chargement des contacts
 * @param {number} chargerContactExclusionMotif - Le motif d'exclusion (0 = aucun)
 * @returns {{message: string, color: string}} Configuration contenant le message et la couleur
 */
export const getConfigChargerContact = (chargerContactExclusionMotif) => {
    const config = chargerContactConfig[chargerContactExclusionMotif];

    if (config) {
        return config;
    }

    return chargerContactConfig.default;
}

export const getResultatRemboursement = (typeRepriseMarchandise, typeRemboursement, seuilMontantMiniAtteint, rebutDeclare, magasin, plvMagasin) => {

    let result = typeRemboursement && typeRepriseMarchandise ? 'Erreur pour le remboursement' : '';

    // Cas de déduction fin de mois (remboursement non autorisé en magasin)
    if (typeRemboursement === RemboursementType.DeductionFinMois) {
        if (typeRepriseMarchandise === RepriseMarchandiseType.Magasin) {
            // Simplification: les deux conditions retournent le même résultat
            return `Génération automatique d'un BL par le magasin de ${magasin}.`
        }
        else if (typeRepriseMarchandise === RepriseMarchandiseType.PlateformeAvoir) {
            if (!seuilMontantMiniAtteint && !plvMagasin) {
                return 'A retourner à la plateforme Monné pour avoir avec le numéro de dossier.'
            }
        }
    }
    // Cas de remboursement en espèces ou CB (autorisé en magasin)
    else if (typeRemboursement === RemboursementType.Especes || typeRemboursement === RemboursementType.Cb) {
        let type = typeRemboursement === RemboursementType.Especes ? "Espèces" : "CB";

        if (typeRepriseMarchandise === RepriseMarchandiseType.Magasin) {
            return `Génération automatique d'une facture par le magasin de ${magasin} avec remboursement ${type}.`
        }

        if (typeRepriseMarchandise === RepriseMarchandiseType.Transfert) {
            return `Génération automatique d'une facture par le magasin de ${magasin} avec remboursement ${type} et transfert vers la plateforme Monné.`
        }
    }
    // Cas de virement (peut être autorisé ou par compta uniquement)
    else if (typeRemboursement === RemboursementType.Virement) {
        if (typeRepriseMarchandise === RepriseMarchandiseType.PlateformeAvoir) {
            return `A retourner à la plateforme Monné pour avoir avec le numéro de dossier.`;
        }

        if (typeRepriseMarchandise === RepriseMarchandiseType.Magasin) {
            return `Génération automatique d'une facture par le magasin de ${magasin}, prendre contact avec l'ACC compta pour le remboursement.`
        }

        if (typeRepriseMarchandise === RepriseMarchandiseType.Transfert) {
            return `Génération automatique d'une facture par le magasin de ${magasin} et transfert vers la plateforme Monné, prendre contact avec l'ACC compta pour le remboursement.`;
        }
    }
    // Cas de carte achat
    else if (typeRemboursement === RemboursementType.CarteAchat) {
        if (typeRepriseMarchandise === RepriseMarchandiseType.PlateformeAvoir) {
            return `A retourner à la plateforme Monné pour avoir avec le numéro de dossier.`
        }
    }

    return result;
}



export const checkClientFermeWarning = (reclamation, autoriseSAV) => {

    //console.log("checkClientFermeWarning", reclamation, autoriseSAV);

    if (reclamation && reclamation.client && reclamation.client.etat === CompteEtat.Ferme) {

        if (reclamation.categorie.code === CategorieCodes.DemandeRetourMarchandiseLivreeConforme) {
            //console.log("checkClientFermeWarning", CategorieCodes.DemandeRetourMarchandiseLivreeConforme);
            return true;
        }

        if (reclamation.categorie.code === CategorieCodes.DefautProduit) {
            // Vérifier qu'il s'agit d'un SAV 
            //console.log("checkClientFermeWarning", CategorieCodes.DefautProduit);

            if (reclamation.qualification.code === QualificationCodes.DefautProduitPremiereUtilisation && autoriseSAV) {

                let detail = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.EtatProduit);
                //console.log("checkClientFermeWarning", CategorieCodes.DefautProduit, QualificationCodes.DefautProduitPremiereUtilisation, `autoriseSAV:${autoriseSAV}`, detail ? detail.valeurInteger : "detail null");
                if (detail && detail.valeurInteger === 1) {

                    return true;
                }
                else {
                    // Vérification du cas SAV by Foussier

                    let detailSavByFoussierConcerne = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.SavByFoussierConcerne);
                    //console.log("checkClientFermeWarning", CategorieCodes.DefautProduit, QualificationCodes.DefautProduitPremiereUtilisation, detailSavByFoussierConcerne);
                    if (detailSavByFoussierConcerne) {

                        return true;
                    }
                }
            }

            if (reclamation.qualification.code === QualificationCodes.DefautProduitPremiereUtilisation && !autoriseSAV) {

                let detail = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.EtatProduit);
                //console.log("checkClientFermeWarning", CategorieCodes.DefautProduit, QualificationCodes.DefautProduitPremiereUtilisation, `autoriseSAV:${autoriseSAV}`, detail ? detail.valeurInteger : "detail null");
                if (detail && detail.valeurInteger === 1) {

                    return true;
                }
            }


            if (reclamation.qualification.code === QualificationCodes.Sav) { // NE DOIT PAS SE PRODUIRE, car c'est transformé en back, voir cas précédent 
                return true;
            }
        }

        if (reclamation.categorie.code === CategorieCodes.ProblemeReception) {
            // Vérifier qu'il s'agit d'un retour

            //console.log("checkClientFermeWarning", CategorieCodes.ProblemeReception, reclamation.qualification.code);

            if (reclamation.qualification.code === QualificationCodes.QuantiteIncorrecte) {

                let detail = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.TypeQuantite);
                //console.log("checkClientFermeWarning", CategorieCodes.ProblemeReception, QualificationCodes.QuantiteIncorrecte, detail ? detail.valeurInteger : "detail null");
                if (detail && detail.valeurInteger === 1) {
                    return true;
                }

            }

            if (reclamation.qualification.code === QualificationCodes.PasBonProduit) {

                let detail = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.ProduitCommande);
                //console.log("checkClientFermeWarning", CategorieCodes.ProblemeReception, QualificationCodes.PasBonProduit, detail ? detail.valeurInteger : "detail null");
                if (detail && (detail.valeurInteger === 1 || detail.valeurInteger === 2)) {
                    return true;
                }
            }
        }
    }

    return false;
}